export default "__VITE_ASSET__m7m0HIY7__"